<template>
  <div class="d-flex align-items-center gap-1 fs-14 text-uppercase">
    <GuBadge
      :variant="props.params.type"
      class="me-2"
    />
    <span v-if="props.params.text" :class="`text-${props.params.type}`">
      {{ props.params.text }}
    </span>
  </div>
</template>

<script setup>
import { GuBadge } from '@shared/gu-components/badge'
const props = defineProps({
  params: {
    type: Object,
    default: () => ({}),
  },
})
</script>
